import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { DashboardStore } from '@seedlang/stores';
import autobind from 'autobind-decorator';
import LineChartWithControls from 'components/visualization/line_chart_with_controls';

const Wrapper = styled.div`

`;

@observer
class SubscriptionsDashboard extends React.Component {
  @observable counts = {};

  componentDidMount() {
    DashboardStore.api({}, this.afterGetUserCounts, 'GET', 'subscriptions');
  }

  @autobind afterGetUserCounts(resp) {
    this.counts = resp;
  }

  render() {
    return (
      <Wrapper>
        <fieldset
          style={{marginBottom: 10}}
        >
          <LineChartWithControls
            namespace='subscription-dashboard-new-subscriptions'
            charts={[
              {
                name: 'Subscriptions By Language',
                resources: [
                  {
                    date_field: 'current_period_start',
                    name: 'Subscription',
                    label: 'German',
                    query: 'target_language_id = \'DE\'',
                  },
                  {
                    date_field: 'current_period_start',
                    name: 'Subscription',
                    label: 'French',
                    query: 'target_language_id = \'FR\'',
                  },
                  {
                    date_field: 'current_period_start',
                    name: 'Subscription',
                    label: 'Spanish',
                    query: 'target_language_id = \'ES\'',
                  },
                ],
              },
              {
                name: 'Subscriptions By Length',
                resources: [
                  {
                    date_field: 'current_period_start',
                    name: 'Subscription',
                    label: 'All Subscriptions',
                  },
                  {
                    date_field: 'current_period_start',
                    name: 'Subscription',
                    label: 'Yearly Subscription',
                    query: 'yearly = TRUE',
                  },
                  {
                    date_field: 'current_period_start',
                    name: 'Subscription',
                    label: 'Monthly Subscription',
                    query: 'yearly = FALSE',
                  },
                ],
              },
            ]}
          />
        </fieldset>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(SubscriptionsDashboard);
